import { ICartState } from "types/improved-booking";

export enum BookingStepName {
  SELECT_DAY = "Select Day",
  SELECT_TIME = "Select Time",
  SELECT_SEAT = "Select Seat",
  SELECT_TICKETS = "Select Tickets",
  ADD_ONS = "Add-Ons",
  ACCREDITATION = "Accreditation",
  CHECKOUT = "Checkout",
}

export interface BookingStep {
  name: BookingStepName;
  title?: string;
  subtitle?: string;
  component: React.FC;
}

export interface ActionCardState {
  currentStepName: BookingStepName;
  cartState: ICartState;
  isTermsAgreementChecked?: boolean;
}

export type TicketStatus = {
  ticketId: string;
  individualPass: boolean;
  individualFail: boolean;
  groupPass?: boolean;
  groupFail?: boolean;
};

export type GroupStatus = {
  groupId: string;
  groupPass: boolean;
  groupFail: boolean;
};
